import React from 'react';
import { toast } from '@/components/ui/sonner';
import { cn } from '@/lib/utils';
import { authService } from '@/services/authService';
import { useNavigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import BusyIndicator from '@/components/BusyIndicator';
import { se } from 'date-fns/locale';

export default function SignUp( { onBackToLogin } : { onBackToLogin: () => void }) {

    const { login } = useApp();
    const [fullName, setFullName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [isBusy, setIsBusy] = React.useState(false);
    const [validObject, setValidObject] = React.useState({
        fullName: true,
        email: true,
        password: true,
        confirmPassword: true,
        phoneNumber: true
    });
    const navigate = useNavigate();

    const handleSubmit = (e) => {  
        setIsBusy(true); 
        e.preventDefault()
             
        if(!fullName){
            setValidObject(prev => ({ ...prev, fullName: false }));
        }
        if(!email){
            setValidObject(prev => ({ ...prev, email: false }));
        }
        if(!password){
            setValidObject(prev => ({ ...prev, password: false }));
        }
        if(!confirmPassword){
            setValidObject(prev => ({ ...prev, confirmPassword: false }));
        }
        if(!phoneNumber){
            setValidObject(prev => ({ ...prev, phoneNumber: false }));
        }
        if(password && confirmPassword && password !== confirmPassword){
            toast.error('\nהסיסמאות לא תואמות\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
            e.preventDefault();
            setIsBusy(false);
            return;
        }
        if(!fullName || !email || !password || !confirmPassword || !phoneNumber){
            toast.error('\nאנא מלא את כל השדות\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
            e.preventDefault();
            setIsBusy(false);
            return;
        }
        const userData = {
            fullName,
            email,
            password,
            phone : phoneNumber
        };
        authService.register(userData).then(async res => {
            
            if(res.success || res.user.id){
                toast.success('\nההרשמה בוצעה בהצלחה\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
                await login({ email: userData.email ,password: userData.password});
                setIsBusy(false);
                navigate('/', { replace: true });
            } else {
                setIsBusy(false);
                toast.error('\nשגיאה בהרשמה\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
            }
        }).catch((error) => {
            
            if(error.status === 422){
                setIsBusy(false);
                toast.error('\nהאימייל כבר קיים במערכת\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
                return;
            }
            setIsBusy(false);
            toast.error('\nשגיאה בהרשמה\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
        })
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
                <h2 className="text-2xl font-bold mb-6 text-center">הרשמה למערכת</h2>
                <form className="space-y-4">
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">שם מלא</label>
                        <input
                            type="text"
                            id="name"
                            value={fullName}
                            onChange={(e) => {  setFullName(e.target.value); setValidObject(prev => ({ ...prev, fullName: !!e.target.value.length }))}}
                            // className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                            className={cn('mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary', !validObject.fullName && 'border-red-500')}
                            placeholder="הכנס שם מלא"
                        />
                    </div>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">אימייל</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e)=> {   setEmail(e.target.value); setValidObject(prev => ({ ...prev, email: !!e.target.value.length }))}}
                            className={cn('mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary', !validObject.email && 'border-red-500')}
                            placeholder="הכנס אימייל"
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">סיסמה</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e)=> {   setPassword(e.target.value); setValidObject(prev => ({ ...prev, password: !!e.target.value.length }))}}
                            className={cn('mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary', !validObject.password && 'border-red-500')}
                            placeholder="הכנס סיסמה"
                        />
                    </div>
                    <div>
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">אישור סיסמה</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e)=> { setConfirmPassword(e.target.value); setValidObject(prev => ({ ...prev, confirmPassword: !!e.target.value.length }))}}
                            className={cn('mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary', !validObject.confirmPassword && 'border-red-500')}
                            placeholder="אשר סיסמה"
                        />
                    </div>
                    <div>
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700">מספר טלפון</label>
                        <input
                            type='number'
                            id="phone"
                            value={phoneNumber}
                            onChange={(e)=> { setPhoneNumber(e.target.value); setValidObject(prev => ({ ...prev, phoneNumber: !!e.target.value.length }))}}
                            className={cn('mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary', !validObject.phoneNumber && 'border-red-500')}
                            placeholder="הכנס מספר טלפון"
                        />
                    </div>
                    <button
                        type="submit"
                        onClick={handleSubmit}
                        className="w-full bg-primary text-primary-foreground py-2 px-4 rounded-md hover:bg-primary/90 transition-colors"
                    >
                        הרשמה
                    </button>
                    <div className="text-sm text-center text-gray-600 mt-4">
                        יש לך חשבון? <a className="text-primary hover:underline" onClick={onBackToLogin}>התחברות</a>
                    </div>
                </form>
            </div>
            {isBusy && <BusyIndicator />}
        </div>
    );
}